import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export default function BtnBack({ onClick }) {
  return (
    <div onClick={onClick} className={styles.btnBack}>
      &lt; Back
    </div>
  );
}

BtnBack.propTypes = {
  onClick: PropTypes.func
};
